import type { ToolRunResult } from '@/services/toolDefinition.service';
import type { StepOutcomes } from '../builder/builder-context';

const STATUSES = new Set(['success', 'simulated', 'error', 'skipped']);

/**
 * Each step's ending from a test run, whose data is keyed by step id. A run that failed on a write still
 * carries every step's outcome, so the cards show how each step ended.
 */
export const outcomesOf = (result: ToolRunResult): StepOutcomes | null => {
	if (!result.data || typeof result.data !== 'object') return null;
	const outcomes: StepOutcomes = {};
	for (const [stepId, value] of Object.entries(result.data as Record<string, unknown>)) {
		const entry = value as { status?: unknown; message?: unknown } | null;
		if (entry && typeof entry.status === 'string' && STATUSES.has(entry.status)) {
			outcomes[stepId] = {
				status: entry.status as StepOutcomes[string]['status'],
				...(typeof entry.message === 'string' ? { message: entry.message } : {})
			};
		}
	}
	return outcomes;
};
